import {
  Table,
  Button,
  Switch,
  Popconfirm,
  Tooltip,
  Avatar,
  Input,
  notification,
  Spin,
} from "antd";
import * as React from "react";
import { get } from "lodash";
import { getAllCourseSession } from "../../Graphs/CourseSession/listCourseSession";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { UserOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { EditModal } from "./EditModal";
import { deleteCourseSession } from "../../Graphs/CourseSession/deleteCourseSession";
import { editCourseSession } from "../../Graphs/CourseSession/editCourseSession";
import { changeStatus } from "../../Graphs/CourseSession/changeStatus";
import { checkPermission } from "../AdminUser/CheckAdminPermission";

var moment = require("moment");

const BASE_IMAGE_URL =
  "https://s3.us-east-2.amazonaws.com/cerebrus-consulting/bloodman_user_media/";

const NativeSelect = ({ value, onChange, children, className }) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className={className}
      style={{
        padding: "3px 8px",
        borderRadius: "4px",
        border: "1px solid #d9d9d9",
        backgroundColor: "#fff",
        outline: "none",
        cursor: "pointer",
        marginLeft: "8px",
        height: "28px"
      }}
    >
      {React.Children.map(children, (child) => {
        if (!child) return null;
        return <option value={child.props.value}>{child.props.children}</option>;
      })}
    </select>
  );
};

class CourseSessionRecordsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      startIndex: 0,
      limitNumber: 10,
      pagination: {
        pageSize: 10,
        current: 1,
      },
    };
    this.handleTableChange = this.handleTableChange.bind(this);
    this.getLimitedCourseSession = this.getLimitedCourseSession.bind(this);
  }

  async componentDidMount() {
      const { course_id } = this.props;
    
      // Hide Course column if viewing within a specific Course detail page
      if (course_id) {
        this.columns = this.columns.filter((item) => item.key !== "course");
      }
    
      // Keep existing state logic
      this.setState({
        data: this.props.data,
        isLoading: false,
        userSelectedData: null,
      });
    }

  modalRef;

  async getLimitedCourseSession(pagination) {
    this.setState({
      pagination: {
        ...this.state.pagination,
        current: pagination.current,
        pageSize: pagination.pageSize,
      }
    });
  }

  listSearchCourseSessionData = async (start, end) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setListCourseSessionData,
        setListCourseSessionDataTotal,
        searchText,
        course_id,
      } = this.props;
      this.setState({
        isLoading: true,
      });

      let courseSessionData = await getAllCourseSession(
        authToken,
        searchText,
        start,
        end,
        course_id
      );

      if (courseSessionData.status === 200) {
        //set user Data
        await setListCourseSessionData(courseSessionData.data);
        // await setListCourseSessionData(courseSessionData.data.docs);
        await setListCourseSessionDataTotal(courseSessionData.total);

        this.setState({
          isLoading: false,
          data: courseSessionData.data,
          // data: courseSessionData.data.docs,
        });
      } else if (courseSessionData.status == 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      console.log("!!!!!!!list search user Data printed here", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  listCourseSessionData = async (start, end) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setListCourseSessionData,
        setListCourseSessionDataTotal,
        course_id,
      } = this.props;
      this.setState({
        isLoading: true,
      });

      let courseSessionData = await getAllCourseSession(
        authToken,
        start,
        end,
        course_id
      );

      if (courseSessionData.status === 200) {
        //set user Data
        await setListCourseSessionData(courseSessionData.data);
        // await setListCourseSessionData(courseSessionData.data.docs);
        await setListCourseSessionDataTotal(courseSessionData.total);

        this.setState({
          isLoading: false,
          data: courseSessionData.data,
        });
      } else if (courseSessionData.status == 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      console.log("!!!!!!!list user Data printed here", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  showModal(item) {
    console.log("open modal", item);
    this.setState({
      courseSelectedData: item,
      isOpen: true
    });
  }

  handleDetailsModalclose() {
    this.setState({
      courseSelectedData: null,
      isOpen: false
    });
  }

  counter = 0;
  tempCounter = 0;
  columns = [
    {
      title: "Sr. No.",
      key: "serial_number",
      width: 70,
      render: (text, item, index) => {
        const { current, pageSize } = this.state.pagination;
        const serialNumber = (current - 1) * pageSize + index + 1;
        return (
          <div>
            <span>{serialNumber}</span>
          </div>
        );
      },
    },
    {
      title: "Name",
      key: "name",
      render: (text, item, index) => {
        console.log("user record --> ", item);
        return (
          <div>
            <strong>
              <Tooltip placement="bottom" title="Name">
                <div>{item.name ? item.name : "-"}</div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Course",
      key: "course",
      render: (text, item, index) => {
        return (
          <div>
            <strong>
              <Tooltip placement="bottom" title="Course">
                <div>
                  {item.courseData &&
                  item.courseData[0] &&
                  item.courseData[0].name
                    ? item.courseData[0].name
                    : "-"}
                </div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    // {
    //   title: "Module",
    //   key: "module",
    //   render: (text, item, index) => {
    //     return (
    //       <div>
    //         <strong>
    //           <Tooltip placement="bottom" title="Module">
    //             <div>{item.moduleData.length >= 1 && item.moduleData[0]['title'] ? item.moduleData[0]['title'] : "-"}</div>
    //           </Tooltip>
    //         </strong>
    //       </div>
    //     );
    //   },
    // },
    {
      title: "Published",
      key: "is_active",
      render: (text, item, index) => {
        const { loginUserData } = this.props;
        const canEdit = checkPermission(loginUserData, "course", "edit");
        return (
          <div>
            {item.is_active != null ? (
              <Tooltip placement="bottom" title="Is Published">
                {
                  <Switch
                    checked={item.is_active}
                    style={{
                      backgroundColor: item.is_active
                        ? this.props.primaryColor
                        : "#bababa",
                    }}
                    onChange={this.onChange.bind(this, item)}
                    disabled={loginUserData.role === "corporate" || !canEdit}
                  />
                }
              </Tooltip>
            ) : (
              "-"
            )}
          </div>
        );
      },
    },
    {
      title: "Actions",
      width: 130,
      key: "action",
      render: (text, item, index) => {
        const { loginUserData } = this.props;
        const canEdit = checkPermission(loginUserData, "course", "edit");
        const canDelete = checkPermission(loginUserData, "course", "delete");
        return (
          <div style={{ display: "inline-block", width: "100%" }}>
            <div mr="5px" style={{ float: "left" }}>
              <Tooltip placement="bottom" title="Edit">
                <Button
                  shape="circle"
                  icon={<EditOutlined />}
                  onClick={() => {
                    this.showModal(item);
                  }}
                  disabled={!canEdit}
                  style={{
                    cursor: canEdit ? "pointer" : "not-allowed",
                    opacity: canEdit ? 1 : 0.5,
                    pointerEvents: canEdit ? "auto" : "none"
                  }}
                />
              </Tooltip>
            </div>
            <div
              ml="15px"
              mr="5px"
              style={{ float: "left", marginLeft: "10px" }}
            >
              <Tooltip placement="bottom" title="Delete">
                {canDelete ? (
                  <Popconfirm
                    onConfirm={this.deleteCourseSessionData.bind(this, item)}
                    title="Are you sure you want to delete Session?"
                  >
                    <Button shape="circle" icon={<DeleteOutlined />} />
                  </Popconfirm>
                ) : (
                  <Button
                    shape="circle"
                    icon={<DeleteOutlined />}
                    disabled
                    style={{
                      cursor: "not-allowed",
                      opacity: 0.5,
                      pointerEvents: "none"
                    }}
                  />
                )}
              </Tooltip>
            </div>
          </div>
        );
      },
    },
  ];

  async deleteCourseSessionData(item) {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setListCourseSessionData,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let deleteData = await deleteCourseSession(authToken, item._id);

      if (deleteData.status === 200) {
        notification["success"]({
          message: "Delete Session",
          description: "Successfully deleted",
        });

        await this.listCourseSessionData(0, 10);
      } else if (deleteData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      notification["error"]({
        message: "Delete Session",
        description: e,
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  async onChange(item, checked) {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let statusData = await changeStatus(authToken, item._id, checked);
      if (statusData.status === 200) {
        notification["success"]({
          message: "Change Session Status",
          description: "Successfully changed status",
        });
        if (searchText != null && searchText !== "") {
          this.listSearchCourseSessionData(startIndex, limitNumber);
          return;
        }
        this.listCourseSessionData(startIndex, limitNumber);
      } else if (statusData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (err) {
      notification["error"]({
        message: "Change Session Status",
        description: err,
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  editSubmit = async (courseObject, courseId) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let statusData = await editCourseSession(authToken, courseObject);
      if (statusData.status === 200) {
        notification["success"]({
          message: "Edit Session Status",
          description: "Successfully edited",
        });
        {
          /*
          if (searchText != null && searchText !== "") {
            this.listSearchCategoryData(startIndex, limitNumber);
            return;
          }*/
        }
        this.handleDetailsModalclose();
        this.listCourseSessionData(startIndex, limitNumber);
      } else if (statusData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      notification["error"]({
        message: "Edit Session Status",
        description: e,
      });
    }
  };

  handleTableChange(pagination, filters) {
    console.log("outer onchange iusers", pagination);
    this.setState(
      {
        pagination,
      },
      () => this.getLimitedCourseSession(pagination)
    );
  }

  render() {
    const { isLoading } = this.state;
    const {
      listCourseSessionData,
      searchLoader,
      loginUserData,
      searchText,
      statusFilter,
      sessionCourseFilter,
    } = this.props;

    let filteredSessionData = listCourseSessionData || [];

    // Client-side search filter
    if (searchText && searchText.trim() !== "") {
      const query = searchText.toLowerCase().trim();
      filteredSessionData = filteredSessionData.filter(session => {
        const name = (session.name || "").toLowerCase();
        const courseName = (session.courseData && session.courseData[0] && session.courseData[0].name || "").toLowerCase();
        return name.includes(query) || courseName.includes(query);
      });
    }

    // Client-side status filter
    if (statusFilter === "active") {
      filteredSessionData = filteredSessionData.filter(session => session.is_active);
    } else if (statusFilter === "inactive") {
      filteredSessionData = filteredSessionData.filter(session => !session.is_active);
    }

    // Client-side course filter
    if (sessionCourseFilter && sessionCourseFilter !== "all") {
      filteredSessionData = filteredSessionData.filter(session => {
        const courseName = (session.courseData && session.courseData[0] && session.courseData[0].name || "").trim();
        return courseName === sessionCourseFilter.trim();
      });
    }

    return isLoading || searchLoader ? (
      <div style={{ marginLeft: "20px" }}>
        <Spin
          size="large"
          style={{ marginLeft: "480px", marginTop: "130px" }}
        />
      </div>
    ) : (
      <div style={{ overflowX: "auto" }}>
        <Table
          loading={this.state.isLoading}
          rowKey={(record) => record._id}
          columns={this.columns}
          size={"small"}
          dataSource={filteredSessionData}
          pagination={{
            total: filteredSessionData.length,
            showSizeChanger: true,
            pageSize: this.state.pagination.pageSize,
            current: this.state.pagination.current,
            pageSizeOptions: ["1", "10", "25", "50", "100"],
            selectComponentClass: NativeSelect,
            onChange: (e) => {
              console.log("onChanges pagination");
              if (e - 1) {
                this.counter = this.tempCounter =
                  (e - 1) * this.state.pagination.pageSize;
                return;
              }
              this.counter = 0;
              this.tempCounter = 0;
            },
          }}
          onChange={this.handleTableChange}
        />

        {this.state.courseSelectedData ? (
          <EditModal
            admin={false}
            visible={this.state.isOpen}
            onClose={this.handleDetailsModalclose.bind(this)}
            courseSelectedData={this.state.courseSelectedData}
            onSubmit={this.editSubmit}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  loginUserData: state.auth.loginUserData,
  listCourseSessionData: state.coursesession.listCourseSessionData,
  listCourseSessionDataTotal: state.coursesession.listCourseSessionDataTotal,
  searchLoader: state.auth.searchLoader,
  searchText: state.auth.searchText,
  statusFilter: state.auth.statusFilter,
  sessionCourseFilter: state.auth.sessionCourseFilter,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginFlag: (flag) => {
      dispatch({
        type: "SET_LOGIN_FLAG",
        flag: flag,
      });
    },
    setUserData: (userData) => {
      dispatch({
        type: "SET_USER_DATA",
        userData: userData,
      });
    },
    setUserToken: (authToken) => {
      dispatch({
        type: "SET_USER_AUTHTOKEN",
        authToken: authToken,
      });
    },
    setListCourseSessionData: (listCourseSessionData) => {
      dispatch({
        type: "SET_LIST_COURSE_SESSION_DATA",
        listCourseSessionData: listCourseSessionData,
      });
    },
    setListCourseSessionDataTotal: (listCourseSessionDataTotal) => {
      dispatch({
        type: "SET_LIST_COURSE_SESSION_DATA_TOTAL",
        listCourseSessionDataTotal: listCourseSessionDataTotal,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CourseSessionRecordsTable));
